"use client";

import { useRouter } from "next/navigation";
import {createRepertoire} from "@/lib/api";

export default function AddToRepertoireButton({ workId }: { workId: number }) {
    const router = useRouter();


    async function handleClick() {
        const data = await createRepertoire(workId);

        router.push(`/repertoire/${data.id}`);
    }

    return (
        <button
            onClick={handleClick}
            className="rounded-xl border px-4 py-2 text-sm transition hover:bg-neutral-100"
        >
            Add to Repertoire
        </button>
    );
}